import $ from 'jquery'

import TopLevelConfigurator from './top-level/TopLevelConfigurator'
import ProductConfigurator from './product/ProductConfigurator'

$(() => {
  const $topLevelWrapper = $('#tl-configurator')

  if ($topLevelWrapper.length) {
    // eslint-disable-next-line no-new
    new TopLevelConfigurator($topLevelWrapper)
  }

  const $variations = $('.variations_form')

  if ($variations.length) {
    // eslint-disable-next-line no-new
    new ProductConfigurator($variations)
  }
})
